<aura-dialog-layout [title]="data.title" [hideActions]="true">
  <div dialog-content class="flex flex-col">
    <div class="mb-4 text-justify" [innerHTML]="data.message"></div>

    <aura-input-code-verification
      [label]="'Code de vérification'"
      [length]="8"
      (complete)="onComplete($event)"
      (resend)="onResend()"
    />
    <!--
    @if (resendCount() >= 1) {
      <button
        mat-button
        class="link"
      >
        Essayer une autre option
      </button>
    }
      -->
  </div>
</aura-dialog-layout>
